import { useState, useEffect } from "react";
import "./style.css";
import { dentalIcons } from "../../../../../../dentail-indetifcation/utils-icons/dentalIcons";

const MatchStageTable = ({ foundStages, onDelete, onTabClick }) => {
  // State to track the currently selected method/tab
  const [selectedMethod, setSelectedMethod] = useState("");
  // Get all available methods from foundStages
  // const methods = foundStages ? Object.keys(foundStages) : [];
  const methods = Object.keys(foundStages).filter(
    (method) => foundStages[method].length > 0
  );

  // Set initial selected method when component mounts or foundStages changes
  useEffect(() => {
    if (methods.length > 0) {
      // Set the first method as default selected
      setSelectedMethod(methods[0]);
    }
  }, [foundStages]);

  // Handle tab click
  const handleTabClick = (method) => {
    setSelectedMethod(method);
    onTabClick(method);
  };

  // Get the current data to display based on selected method
  const getCurrentData = () => {
    if (selectedMethod && foundStages && foundStages[selectedMethod]) {
      const methodData = foundStages[selectedMethod];
      return methodData;
    }
    return [];
  };

  // Get the current display data
  const displayData = getCurrentData();

  return (
    <div className="match_stage_table_container">
      <div className="match_stage_table_body">
        <div className="_header">
          <p>Preview Selections</p>
        </div>
        <div className="_main">
          {/* Show tabs only if there are multiple methods */}
          {methods.length > 0 && (
            <div className="method_tabs">
              {methods.map((method, index) => (
                <div
                  key={index}
                  className={`method_tab ${
                    selectedMethod === method ? "active" : ""
                  }`}
                  onClick={() => handleTabClick(method)}
                >
                  {method === "collation_b"
                    ? "Collation"
                    : method
                        .replace(/_/g, " ")
                        .replace(/\b\w/g, (char) => char.toUpperCase())}
                </div>
              ))}
            </div>
          )}

          <div className="_table">
            <div className="header">
              <span className="_secondColumn">Tooth Position</span>
              <span className="_secondColumn">Tooth Name</span>
              <span className="_fistColumn">Stage Diagram</span>
              <span className="_secondColumn">Stage Information</span>
              <span className="_lastColumn">Action</span>
            </div>
            {displayData?.map((item, index) => {
              return (
                <div className="body" key={index}>
                  <div className="_tooh_postion">
                    <p>ISO 71, 72, 73, 74, 75</p>
                  </div>
                  <div className="_tooh_name">
                    <p>Lower Left Teeth</p>
                  </div>
                  <div className="_diagram">
                    <img
                      src={item?.diagram || "/placeholder.svg"}
                      alt={item?.description || "Stage diagram"}
                    />
                  </div>
                  <div className="_stage">
                    <p>{item?.description}</p>
                    <span>Matched</span>
                  </div>
                  <div className="_action">
                    <img
                      src={dentalIcons.binIcon || "/placeholder.svg"}
                      alt="Delete"
                      onClick={() => onDelete(item)}
                    />
                  </div>
                </div>
              );
            })}

            {/* Show message if no data is available */}
            {(!displayData || displayData.length === 0) && (
              <div className="no_data">
                <p>No stages found for this method</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MatchStageTable;
